import styled from "styled-components";
import { layout } from '../../../package.json';

export const BarContainer = styled.div`
  width: 100%;
  height: 20px;
  background: #eee;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 8px;
`;

export const ProgressBar = styled.div<{ width: number; expired: boolean }>`
  height: 100%;
  width: ${({ width }) => width}%;
  background: ${({ expired }) => (expired ? "var(--primary)" : "var(--primary)")};
  transition: width 1s linear;
`;

export const Label = styled.div`
  text-align: right;
  font-size: 18px;
  margin-top: 5px;
  color: #333;

  @media (max-width: ${layout.tablet}) {
      font-size: 0.7rem;
  }
`;
